import React, { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Collapse, ConfigProvider, Flex } from '@app/ui';
import './ReportsConfig.scss';

export type FilterSelectionType = {
    title: string;
    displayValues?: string[];
};

type ReportsConfigContainerProps = {
    children?: React.ReactNode;
};

const ReportsConfigContainer = ({ children }: ReportsConfigContainerProps) => {
    const { t } = useTranslation('tools');
    const [isExpanded, setIsExpanded] = useState(false);
    const stickyRef = useRef<HTMLDivElement>(null);
    const [isAtTop, setIsAtTop] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            if (stickyRef.current) {
                const top = stickyRef.current.getBoundingClientRect().top;
                setIsAtTop(top <= 60);
            }
        };

        window.addEventListener('scroll', handleScroll);
        handleScroll();

        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const titleContent = (
        <Flex>
            <Flex
                gap={12}
                justify="center"
                align="center"
                className="-m-r-2"
                style={{
                    height: 'fit-content',
                    fontSize: 14,
                }}
            >
                <i className="fa-regular fa-gear" />
                {t('reports.config.title')}
            </Flex>
        </Flex>
    );

    return (
        <ConfigProvider
            theme={{
                components: {
                    Collapse: {
                        headerBg: !isAtTop ? '#FAFAFA' : '#FFF',
                        colorBorder: !isAtTop ? '#BFBFBF' : '#FFF',
                    },
                },
            }}
        >
            <Collapse
                className="sticky"
                ref={stickyRef}
                style={{
                    top: 60,
                    position: 'sticky',
                    overflow: 'hidden',
                    ...(isAtTop && {
                        borderTop: 'none',
                        borderLeft: 'none',
                        borderRight: 'none',
                        width: 'calc(100% + 48px)',
                        transform: 'translateX(-24px)',
                        borderRadius: '0',
                        boxShadow: '0 4px 4px -2px rgba(0, 0, 0, 0.25)',
                    }),
                }}
                activeKey={isExpanded ? ['1'] : []}
                onChange={() => setIsExpanded(!isExpanded)}
                expandIconPosition="end"
                items={[
                    {
                        key: '1',
                        label: titleContent,
                        children: (
                            <div className="filters-accordion__selects">
                                {children}
                            </div>
                        ),
                    },
                ]}
            />
        </ConfigProvider>
    );
};

export default ReportsConfigContainer;
